import { SET_CAMPAIGN_VOICE_LIST } from '../../mutation-types';
import { getCampaignVoiceList } from '@/services/campaigns-service';

const actions = {
  async getCampaignVoiceList({ commit, rootState }) {
    const agentId = rootState.attendance.Attendance.agentId;

    await getCampaignVoiceList(agentId).then((response) => {
      const campaigns = response.map(
        ({
          id,
          attendance_group_id,
          dialer_execution_status,
          name,
          dialer_execution,
        }) => ({
          strategy_campaign_id: id,
          attendance_group_id,
          dialer_execution_status,
          name,
          dialer_execution,
        }),
      );
      commit(SET_CAMPAIGN_VOICE_LIST, campaigns);
    });
  },
};

export default actions;
